import { Dict } from '@oneweb/reach-me-lib/src/typeScriptHelpers'
import main from './main.json'

export type Region = 'emea' | 'amap' | 'china'

export interface MainConfig {
  title: string
  countryToRegion: Dict<Region>
}

export default main as MainConfig
